import AContainer from "../../library/ExtendedObjects/AContainer.js";

export default class ShadowItem extends AContainer
{
    constructor(scene, x, y, shadowOpacity, frame, xOffset, yOffset, angle = 0, scaleX = 1, scaleY = 1, ...childrenUnderneath)
    {
        super(scene, x, y);

        this.add(childrenUnderneath);

        this.shadow_maxOffset_X = xOffset;
        this.shadow_maxOffset_Y = yOffset;
        this.shadow = this.scene.addImage(x + this.shadow_maxOffset_X, y + this.shadow_maxOffset_Y, frame);
        this.shadow.tint = 0x004466;
        this.shadow.alpha = shadowOpacity;
        
        this.angle = angle;
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        this.shadow.scaleX = scaleX;
        this.shadow.scaleY = scaleY;
        this.base = this.create(0, 0, frame);
        this.scene.add.existing(this);

        this.setDepth(2);
    }

    set angle(value)
    {
        super.angle = value;
        this.shadow.angle = value;
    }

    get angle()
    {
        return super.angle;
    }

    set scale(value)
    {
        this.setScale(value);
        this.shadow.setScale(value);
    }

    get scale()
    {
        return super.scaleX;
    }
}